<template>
  <div class="schedule" id="schedule">
    <div class="header" :style="{backgroundColor:isComing?'#ff3c00':'#fff'}">
      <img src="https://summit-img.geekpark.net/mobile/%E4%B8%BB%E8%AE%BA%E5%9D%9B-mobile-%E9%BB%91.svg"
           v-show="!isComing">
      <img src="https://summit-img.geekpark.net/mobile/%E4%B8%BB%E8%AE%BA%E5%9D%9B-mobile-%E7%99%BD.svg"
           v-show="isComing">
    </div>
    <div class="content" style="text-align: left;">
      <div class="day-one">
        <div class="panel">
          <img src="https://summit-img.geekpark.net/ifx/pc/v4-12.20-%E5%91%A8%E4%BA%94.svg">
          <div class="text-container">
            <p>
              12 月 20 日，极客公园创始人兼总裁张鹏，将联合得到 App
              总编辑李翔，奉献一场关于商业常识与真相的思维共振。围绕微信、小米、支付宝、美团、拼多多、字节跳动、滴滴这些大众熟知的企业，让我们回顾上一个十年的互联网往事，预演下一个十年的商业算法。
            </p>
          </div>
        </div>
        <div class="panel-content">
          <img src="https://summit-img.geekpark.net/mobile/IFX-v3-%E7%BD%91%E7%AB%99%E5%88%87%E5%9B%BE-m.png"
               style="width: 100vw;margin-left: -5vw;margin-bottom: 10vw;">
          <a class="replay-btn-link1" data-href="https://p.bokecc.com/playhtml.bo?vid=283DC1D9E60097BB9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link2 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=F08273812EB9BF3A9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link3 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=F75E1B33B5C484BA9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link4 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=EE955560E367A6979C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link5 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=7AA1BBDF700142889C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link6 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=89A59F3C8095B3749C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
          <a class="replay-btn-link7 replay-btn-link" data-href="https://p.bokecc.com/playhtml.bo?vid=D8C9706E80BF599F9C33DC5901307461&siteid=99F117B348066991&autoStart=true&playerid=AB64ED27A1261F77&playertype=1">
            <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
          </a>
        </div>
      </div>
      <div class="day-two">
        <img src="https://summit-img.geekpark.net/mobile/%E4%BA%AE%E7%82%B9.svg" style="width: 100%">
        <p style="width: 70%;margin: 10vw auto 12vw auto">
          在「未来趋势论坛」和「极致成长论坛」中， 你将听到科技先锋力量们对以下六个问题的探讨和思考：
        </p>
        <img src="https://summit-img.geekpark.net/mobile/questions.png"
             style="width: 80vw;display: block;margin: auto auto 10vw auto">
        <div class="panel">
          <img src="https://summit-img.geekpark.net/ifx/pc/v3-12.21-%E5%91%A8%E5%85%AD.svg">
          <div class="text-container">
            <p>
              世界前行的方向总是由少数派掌控，他们屏蔽喧嚣、独立思考，用虔诚的科技信仰与独树一帜的判断力引领产业形成共同的价值认同。什么是未来？崛起的先锋力量，他们便是答案。
            </p>
          </div>
        </div>
        <div class="item-one" v-for="(item,index) in schedule21" :key="index">
          <div class="head">
            <span class="time">{{item.start_at | parseTime}}</span>
            <img src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '小众与大众'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '突破与传承'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '虚拟与现实'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '科技与人性'">
            <img
              src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
              style="height: 5vw; width: auto;" v-if="item.description === '人工智能与人'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '传统与创新'">
          </div>
          <h2>{{item.title}}</h2>
          <div v-if="item.image" style="text-align: left">
            <img :src="item.image" style="width: 60%;vertical-align: bottom;">
          </div>
          <div class="guest" v-else>
            <img :src="item.guests[0].avator.url">
            <div class="guest-info">
              <div class="replay-btn-wrapper">
                <span class="company">{{item.guests[0].company}}</span>
                <a class="replay-btn-link" :data-href="item.live_url||'https:if.geekpark.net/'">
                  <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
                </a>
              </div>
              <div class="bottom">
                <span class="name">{{item.guests[0].name}}</span>
                <span class="position">{{item.guests[0].title}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="day-three">
        <div class="panel">
          <img src="https://summit-img.geekpark.net/ifx/pc/v3-12.22-%E5%91%A8%E6%97%A5.svg">
          <p>
            成长是商业组织的永恒话题，如何寻找创新原点，如何看清商业的规律，如何突破瓶颈持续向上，是每一个「企业家」的必修课。
          </p>
        </div>
        <div class="item-one" v-for="(item,index) in schedule22" :key="index">
          <div class="head">
            <span class="time">{{item.start_at | parseTime}}</span>
            <img src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '小众与大众'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '突破与传承'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '虚拟与现实'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '科技与人性'">
            <img
              src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
              style="height: 5vw; width: auto;" v-if="item.description === '人工智能与人'">
            <img src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                 style="height: 5vw; width: auto;" v-if="item.description === '传统与创新'">
          </div>
          <h2>{{item.title}}</h2>
          <div v-if="item.image" style="text-align: left">
            <img :src="item.image" style="width: 60%;vertical-align: bottom;">
          </div>
          <template v-if="!item.image && item.guests.length > 1">
            <div class="guest" v-for="(value,key) in item.guests" :key="key">
              <img :src="item.guests[key].avator.url">
              <div class="guest-info">
                <div class="replay-btn-wrapper">
                  <span class="company">{{item.guests[key].company}}</span>
                  <a v-if="key===0"  class="replay-btn-link" :data-href="item.live_url||'https://if.geekpark.net/'">
                    <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
                  </a>
                </div>
                <div class="bottom">
                  <span class="name">{{item.guests[key].name}}</span>
                  <span class="position">{{item.guests[key].title}}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!item.image && item.guests.length === 1">
            <div class="guest">
              <img :src="item.guests[0].avator.url">
              <div class="guest-info">
                <div class="replay-btn-wrapper">
                  <span class="company">{{item.guests[0].company}}</span>
                  <a  class="replay-btn-link" :data-href="item.live_url||'https://if.geekpark.net/'">
                    <img class="replay-btn" src="https://summit-img.geekpark.net/ifx/images/replay_btn.svg"/>
                  </a>
                </div>
                <div class="bottom">
                  <span class="name">{{item.guests[0].name}}</span>
                  <span class="position">{{item.guests[0].title}}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <img src="https://summit-img.geekpark.net/mobile/%E6%97%A5%E7%A8%8B%E6%8C%81%E7%BB%AD%E6%9B%B4%E6%96%B0.svg"
           style="width: 100%;margin-bottom: 12vw;margin-top: -4vw">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'

export default {
  name: 'Schedule',
  data () {
    return {
      schedule21: [],
      schedule22: [],
      isComing: false,
      schedules: []
    }
  },
  created () {
    axios.get('https://events.geekpark.net/api/v1/activities/f17e2e76-b88b-42e9-a311-48897ae5ba8a').then(res => {
      this.$emit('updatePartners', res.data.activity.partner_categories)
      const schedule21 = res.data['vice_activities'][0].speeches[0].speeches.sort((prev, next) => {
        return moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
      })
      const schedule22 = res.data['vice_activities'][1].speeches[0].speeches.sort((prev, next) => {
        return moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
      })
      this.schedule21 = schedule21
      this.schedule22 = schedule22
      this.handleClickReplay()
    })
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  filters: {
    parseTime: function (date) {
      return moment(date).format('HH:mm')
    }
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scheduleTop = this.getElementTop(document.querySelector('#schedule'))
      if (scrollHeight > scheduleTop - 400) {
        this.isComing = true
      }
    },
    handleClickReplay () {
      $('.content').on('click', '.replay-btn-link', function (e) {
        const viframe = $('#ifx_video_iframe')
        const is = viframe.attr('src')
        if (is === e.currentTarget.dataset.href) return
        $('#ifx_video_iframe_wrapper').css('display', 'block')
        viframe.attr('src', e.currentTarget.dataset.href)
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .header {
    box-sizing: border-box;
    width: 90vw;
    margin: auto;
    padding: 8vw 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    transition: background-color .7s;

    img {
      width: 76vw;
    }
  }

  .item-one {
    box-sizing: border-box;
    margin-top: 4vw;
    padding: 3vw;
    background-color: #f9f9f9;

    &:last-of-type {
      margin-bottom: 10vw;
    }

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .time {
        color: #ff3c00;
        font-family: SyncopateBold;
        font-weight: bold;
        font-size: 5.5vw;
      }
    }

    > h2 {
      margin: .5vw auto 3vw auto;
      font-size: 5vw;
    }

    .guest {
      display: flex;
      justify-content: flex-start;

      &:not(:first-of-type) {
        margin-top: 4vw;
      }

      img {
        width: 14vw;
        height: 14vw;
        border-radius: 7vw;
      }

      .guest-info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 5vw;
        width: 100%;

        .replay-btn-wrapper{
          display: flex;
          justify-content: space-between;
          align-items: center;
          img{
            width: 14vw;
            height: auto;
          }
        }

        .company {
          color: #ff3c00;
          font-size: 4.8vw;
          font-weight: 800;
        }

        .bottom {
          font-size: 4vw;

          .name {
            margin-right: 3.8vw;
          }

          .position {
            color: #535353;
          }
        }
      }
    }
  }

  .content {
    width: 90vw;
    margin: auto;

    .panel {
      margin-bottom: 6vw;
      padding: 9vw 8vw;
      background-color: #f9f9f9;
    }

    > div {
      display: flex;
      flex-direction: column;
      padding-top: 10vw;

      &:not(:last-of-type) {
        border-bottom: 1px solid #000;
      }

      img {
        width: 100%;
      }

      p {
        width: 90%;
        margin-top: 10vw;
        line-height: 1.6;
        color: #1D1D1D;
        text-align: justify;
        font-size: 4vw;
      }
    }

    .panel-content{
      position: relative;
      .replay-btn{
        width: 14vw;
        height: auto;
      }
      .replay-btn-link1{
        position: absolute;
        top: 29vw;
        right: 28vw;
      }
      .replay-btn-link2{
        position: absolute;
        top: 83vw;
        left: -2vw;
      }
      .replay-btn-link3{
        position: absolute;
        top: 83vw;
        right: 28vw;
      }
      .replay-btn-link4{
        position: absolute;
        top: 141vw;
        left: -2vw;
      }
      .replay-btn-link5{
        position: absolute;
        top: 141vw;
        right: 28vw;
      }
      .replay-btn-link6{
        position: absolute;
        top: 194vw;
        left: -2vw;
      }
      .replay-btn-link7{
        position: absolute;
        top: 194vw;
        right: 28vw;
      }

    }
  }
</style>
